import React, { useEffect, useState } from 'react'
import { API } from '../../../api/Api';

const GrainDropDown = ({ onGrainSelect, className, value }) => {
    
    const [grain, setGrain] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchGrain = async () => {
        // const url = API_ROUTES.GET_ACTIVITY_LIST;
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getvisualizermasterlist';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { type: "grain" };

        try {
            const token = localStorage.getItem('token');
            const response = await API(url, requestBody, token);

            if (response) {
                setGrain(response.Data);
            }
        } catch (error) {
            setError('Error fetching Grain');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGrain();
    }, []);

    if (loading) return <p className='text-sm my-4 mx-2'>Loading Grains...</p>;
    if (error) return <p>{error}</p>;
    return (
        <div className="mb-4">
            <select
                value={value}
                onChange={(e) => onGrainSelect(e.target.value)}
                className={`${className} border rounded px-4 py-2 focus:outline-none focus:ring focus:ring-blue-300 transition`}
            >
                <option value="">Select Grain Type</option>
                {grain.map((grain) => (
                    <option key={grain.id} value={grain.id}>
                        {grain.name}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default GrainDropDown